"use client";

import { useAuthStore } from "@/lib/auth/store";
import { useMemo } from "react";
import { hasScope } from "../auth/scope-utils";

const GENCISE_DOMAIN = "gencise.ai";

/**
 * Hook to check if the current user's email belongs to the gencise.ai domain.
 * This is used to gate internal/developer features.
 */
export function useIsGenciseUser(): boolean {
  const user = useAuthStore((state) => state.user);

  if (!user) {
    return false;
  }

  const emailDomain = user.email.split("@")[1]?.toLowerCase();
  return emailDomain === GENCISE_DOMAIN;
}

export function useIsFullAdmin(): boolean {
  const user = useAuthStore((state) => state.user);
  return useMemo(() => hasScope(user?.scopes, "admin"), [user?.scopes]);
}
